import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArIQ: CultureInfo = {
  name: 'ar-IQ',
  displayName: 'Arabic (Iraq)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-IQ',
  parent: CultureInfoAr
};
